import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "ui/components";
import { useSessionContext } from "ui/context/SessionContext";
import styles from "./Error.module.scss";

const Error: React.FC = () => {
    const sessionContext = useSessionContext();
    const navigate = useNavigate();

    const reload = () => {
        navigate("/clips");
    };

    const logout = () => {
        sessionContext.setSession(null);
        navigate("/login");
    };

    return (
        <div className={styles.errorpage}>
            <div className={styles.message}>
                {sessionContext.error || "No error here"}
            </div>
            <div className={styles.buttonbar}>
                <Button type="secondary" icon="replay" onClick={reload}>
                    Try again
                </Button>
                {sessionContext.session && (
                    <Button type="secondary" icon="user" onClick={logout}>
                        Log out
                    </Button>
                )}
            </div>
        </div>
    );
};

export default Error;
